<template>
  <v-dialog
    max-width="600px"
    v-model="new_tag_dialog">
    <AddTag
      v-on:close="new_tag_dialog = false"
      v-if="new_tag_dialog"
      :selected="selected" />
  </v-dialog>
  <div style="display: flex">
    <div style="font-weight: bold; font-size: 20px">
      <v-icon class="mr-3">mdi-tag-multiple-outline</v-icon>
      Tags
    </div>
    <v-spacer />
    <HelpButton mdx-name="TaggingConfig" />
  </div>
  <v-divider class="mt-3" />
  <div class="config-page-body">
    <div style="margin-top: 40px; margin-bottom: 20px">
      <div></div>
      <v-card-subtitle>Edit Tags</v-card-subtitle>
      <v-divider />
    </div>
    <v-card-actions class="ma-0 pa-0 mt-2">
      <v-spacer></v-spacer>
      <v-btn
        color="primary"
        variant="tonal"
        @click="
          selected = undefined;
          new_tag_dialog = true;
        ">
        Add Tag
      </v-btn>
    </v-card-actions>
    <TagsViewer
      v-if="deluge?.tags"
      :editMode="true"
      :tagContainerHeight="true"
      :tags="Object.values(deluge.tags)"
      @select="HandleTagClick"
      :selectable="false" />
  </div>
</template>
<script setup>
import AddTag from './add_tag.vue';
import Tag from '../Shared/Tag.vue';
import { deluge } from '@/stores/deluge.js';
import { defineProps, ref } from 'vue';
import TagsViewer from '../Shared/TagsViewer.vue';
import HelpButton from '../Help-Hints/HelpButton.vue';

function HandleTagClick(tag) {
  selected.value = tag;
  new_tag_dialog.value = true;
}

const props = defineProps(['tags']);
const new_tag_dialog = ref(false);
const selected = ref(undefined);
</script>
<style scoped>
@import './config.css';
</style>
